function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-227.000000, -377.000000)",
  fill: "#183E6B",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(214.000000, 362.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11,0.76 C0.1892,0.76 0,1.66805195 0,8.76 C0,15.8519481 0.1892,16.76 11,16.76 C21.8108,16.76 22,15.8519481 22,8.76 C22,1.66805195 21.8108,0.76 11,0.76 Z M14.0671779,9.08102329 L9.23157346,11.0960071 C8.80832346,11.2709723 8.46153846,11.0748574 8.46153846,10.6576327 L8.46153846,6.86223389 C8.46153846,6.44597054 8.80832346,6.24889436 9.23157346,6.42385955 L14.0671779,8.43884334 C14.4904279,8.61573123 14.4904279,8.9041354 14.0671779,9.08102329 Z"
}))))));
var SvgIconYoutube = function SvgIconYoutube(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "17px",
    viewBox: "0 0 22 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-youtube.2150bddc.svg";
export { ForwardRef as ReactComponent };